import { QRCodeSVG } from 'qrcode.react'
import { cn } from '../lib/utils'

// The white plate a QR needs to scan reliably against a dark UI. Shared so
// every invite surface renders the code at the same size and contrast.
export function QrCodeBox({
  value,
  size = 224,
  className,
}: {
  value: string
  size?: number
  className?: string
}) {
  return (
    <div className={cn('rounded-lg bg-white p-4', className)}>
      {value && <QRCodeSVG value={value} size={size} level="M" />}
    </div>
  )
}
